import React from "react";
import Title from "components/Title";
import PostFilters from "../../../components/PostFilters/PostFilters";
const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="findPet.title" className='gx-pb-3' />
      <PostFilters type="find" recordName='findPetList' />
    </div>
  );
};

export default TableHeader;
